export default __webpack_public_path__ + "static/media/ssl.cf242cec.svg";